import { Row, Column, Button, Typo, toast } from 'components/ui-kit';
import { useFormikContext } from 'formik';
import { MutableRefObject } from 'react';

type TSubmitFormProps = {
  formRef: MutableRefObject<HTMLFormElement | null>;
};

export const SubmitForm = ({ formRef }: TSubmitFormProps): JSX.Element => {
  const formikHelpers = useFormikContext();

  const handleSubmit = (): void => {
    formikHelpers.handleSubmit();

    if (!formikHelpers.isValid) {
      formRef.current?.scrollIntoView();
      toast.error('Проверьте поля: что-то важное осталось незаполненным');
    }
  };

  return (
    <Row>
      <Column span={{ s: 12, l: 8 }}>
        <Typo variant="xm">
          Нажимая на&nbsp;кнопку &laquo;Перейти к&nbsp;оплате&raquo;,
          вы&nbsp;принимаете условия публичной оферты. Оплатите заказ онлайн
          с&nbsp;помощью банковской карты, другие способы оплаты пока
          недоступны.
        </Typo>
      </Column>
      <Column span={{ s: 12, l: 4 }}>
        <Button
          isDisabled={formikHelpers.isSubmitting}
          type="button"
          variant="primary"
          isLoading={formikHelpers.isSubmitting}
          onClick={handleSubmit}
        >
          Перейти к оплате
        </Button>
      </Column>
    </Row>
  );
};
